import React from 'react';
import './Settings.css';

const Settings = () => {
  return (
    <div className="settings-page">
      <div className="main-title">Settings</div>
      
      <div className="settings-content">
        <div className="settings-section">
          <h3>General Settings</h3>
          <div className="setting-item">
            <div className="setting-info">
              <div className="setting-label">Email Notifications</div>
              <div className="setting-description">Receive email alerts for important events</div>
            </div>
            <label className="toggle-switch">
              <input type="checkbox" defaultChecked />
              <span className="toggle-slider"></span>
            </label>
          </div>
          
          <div className="setting-item">
            <div className="setting-info">
              <div className="setting-label">Auto Backup</div>
              <div className="setting-description">Automatically backup data every 24 hours</div>
            </div>
            <label className="toggle-switch">
              <input type="checkbox" />
              <span className="toggle-slider"></span>
            </label>
          </div>
        </div>
        
        <div className="settings-section">
          <h3>Security Settings</h3>
          <div className="setting-item">
            <div className="setting-info">
              <div className="setting-label">Two-Factor Authentication</div>
              <div className="setting-description">Add an extra layer of security to your account</div>
            </div>
            <button className="configure-btn">Configure</button>
          </div>
          
          <div className="setting-item">
            <div className="setting-info">
              <div className="setting-label">Session Timeout</div>
              <div className="setting-description">Automatically log out after inactivity</div>
            </div>
            <select className="setting-select">
              <option>30 minutes</option>
              <option>1 hour</option>
              <option>4 hours</option>
              <option>Never</option>
            </select>
          </div>
        </div>
        
        <div className="settings-section">
          <h3>API Settings</h3>
          <div className="setting-item">
            <div className="setting-info">
              <div className="setting-label">API Rate Limiting</div>
              <div className="setting-description">Limit API requests per minute</div>
            </div>
            <input type="number" className="setting-input" defaultValue="100" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings; 